export const shouldDisplayVisuallySimilar = (data = {}) => {
  return data?.product?.info?.recommendationFlags?.visualNavigation;
};

export const shouldDisplayIrgaccessories = (data = {}) => {
  return (data?.product?.info?.recommendationFlags?.ACC);
};

export const shouldDisplayIrgcollections = (data = {}) => {
  return data?.product?.info?.recommendationFlags?.collections;
};

export const getIRGSchema = (data) => {
  const irgColl = shouldDisplayIrgcollections(data);
  const irgAcc = shouldDisplayIrgaccessories(data);
  if (irgColl && irgAcc) return ['irgcollection', 'irgaccessories'];
  if (!irgColl && irgAcc) return ['irgaccessories'];
  if (irgColl && !irgAcc) return ['irgcollection'];
  return [];
};
